import * as React from 'react';
import styled from '@emotion/styled';
import { Outlet } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Sidebar from '../Sidebar';
import Header from '../../Header';
import Footer from '../../Footer';

const StyledMain = styled.div`
  display: flex;
  flex: 1;
`;

const Layout = () => (
  <>
    <Header />
    <StyledMain>
      <Sidebar />
      <Outlet />
    </StyledMain>
    <Footer />
  </>
);

export default withAuthenticationRequired(Layout, {
  onRedirecting: () => <div>Redirecting you to the login page...</div>,
});
